import {
  ExtractIcon,
  FlowerIcon,
  GearIcon,
  GrowIcon,
  GummyIcon,
  JaneGoldIcon,
  MerchIcon,
  NugIcon,
  PrerollIcon,
  StarFilledIcon,
  TagIcon,
  TinctureIcon,
  TopicalIcon,
  VapeIcon,
} from '@iheartjane/reefer';
import merge from 'lodash-es/merge';
import type { ReactElement } from 'react';

import type { CategoryMetaBase, MenuCategoryTab } from '../../../util';
import { categories as baseCategories } from '../../../util';
import { AllProductsIcon } from '../Icons/AllProductsIcon';
import type { KioskIconProps } from '../Icons/KioskIconProps';

export interface CategoryMeta extends CategoryMetaBase {
  Icon: (props: KioskIconProps) => ReactElement;
}

export const categories: Record<MenuCategoryTab, CategoryMeta> = merge(
  baseCategories,
  {
    all: {
      Icon: AllProductsIcon,
    },
    'alt-flower': {
      Icon: NugIcon,
    },
    edible: {
      Icon: GummyIcon,
    },
    extract: {
      Icon: ExtractIcon,
    },
    featured: {
      Icon: StarFilledIcon,
    },
    flower: {
      Icon: FlowerIcon,
    },
    'jane-gold': {
      Icon: JaneGoldIcon,
    },
    gear: {
      Icon: GearIcon,
    },
    grow: {
      Icon: GrowIcon,
    },
    merch: {
      Icon: MerchIcon,
    },
    'pre-roll': {
      Icon: PrerollIcon,
    },
    sale: {
      Icon: TagIcon,
    },
    specials: {
      Icon: TagIcon,
    },
    tincture: {
      Icon: TinctureIcon,
    },
    topical: {
      Icon: TopicalIcon,
    },
    vape: {
      Icon: VapeIcon,
    },
  }
);
